import { render, staticRenderFns } from "./TilesFormGroup.vue?vue&type=template&id=5412a2bb&"
import script from "./TilesFormGroup.vue?vue&type=script&lang=js&"
export * from "./TilesFormGroup.vue?vue&type=script&lang=js&"
import style0 from "./TilesFormGroup.vue?vue&type=style&index=0&id=5412a2bb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports